import React, { useState, useEffect, useRef } from "react";
import { styles } from "../styles/ChatWindow.styles";
import { useAuth } from "../context/AuthContext";
import { getMessages,sendFileMessage} from "../services/message";
import { formatDate,getCurrentDateTime,arrayBufferToBase64,toImageSrc,formatDatePT,parseDate,parseDateFlexible,formatToPtPt } from "../utils/utils";
import { getParticipants } from "../services/participants";
import { MdGroup, MdAutoAwesome, MdSend} from "react-icons/md";
import { FaUser, FaUserPlus, FaCrown, FaCircle, FaCheck, FaCheckDouble, FaPaperclip, FaFileAlt } from "react-icons/fa";
import { IoChevronBackCircle, IoEllipsisVertical } from "react-icons/io5";
import { FaUserGroup } from "react-icons/fa6";
import AddParticipantModal from "../components/addParticipantModal";
import GroupDetails from "../components/GroupDetails";
import { useSocket } from "../context/SocketContext";
import { useNavigate } from "react-router-dom";
import { FaUserShield  } from "react-icons/fa6";
import { HiOutlineLogout } from "react-icons/hi";
import { VscArrowDown } from "react-icons/vsc";
import { getIAConfig } from "../services/ia";

function DaySeparator({ date }) {
  const d = parseDateFlexible(date);
  if (!d) return null;

  const today = new Date();
  const yesterday = new Date();

  yesterday.setDate(today.getDate() - 1);

  const isSameDate = (a, b) =>
    a.getFullYear() === b.getFullYear() &&
    a.getMonth() === b.getMonth() &&
    a.getDate() === b.getDate();

  let label = "";

  if (isSameDate(d, today)) {
    label = "Hoje";
  } else if (isSameDate(d, yesterday)) {
    label = "Ontem";
  } else {
    const dayDiff = (today - d) / (1000 * 60 * 60 * 24);

    if (dayDiff < 7) {
      label = d.toLocaleDateString("pt-PT", { weekday: "long" });
    } else {
      label = d.toLocaleDateString("pt-PT", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric"
      });
    }
  }

  return (
    <div style={styles.daySeparatorContainer}>
      <span style={styles.daySeparatorLabel}>{label}</span>
    </div>
  );
}
function TypingIndicator({ isMe }) {
  return (
    <div style={styles.typingIndicator(isMe)}>
      {[0, 1, 2].map((i) => (
        <span
          key={i}
          style={{
            ...styles.typingDot,
            backgroundColor: isMe ? "#fff" : "#111827",
            animationDelay: `${i * 0.2}s`,
          }}
        />
      ))}
    </div>
  );
}


function ChatWindow({isMobile,conversationData,onBack,setConversationData,setSelectedConversation,setActiveMenu,refreshChats }) {
  const navigate = useNavigate();
  const conversationId = conversationData?.STAMP;
  const conversationLogoFromData = conversationData?.FOTO || conversationData?.LOGO;
  
  const isPrivate = conversationData?.TIPO === "private";
  const isTemp = conversationData?.IS_TEMP;
  const stampTomadorFromConversation = conversationData?.STAMPTOMADOR;
  const stampUtilizadorFromConversation = conversationData?.STAMPUTILIZADOR;
  const  ParticipantUtilizador = conversationData?.PARTICIPANTES;
  const { token, stampTomador } = useAuth(); 
  const [messages, setMessages] = useState([]);
  const [participants, setParticipants] = useState([]);
  const normalizeName = (value) =>
    String(value || "")
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .trim()
      .toLowerCase();
  const matchingParticipant = participants.find(
    (participant) =>
      normalizeName(participant?.NOME) === normalizeName(conversationData?.NOME)
  );

  
  const conversationLogo = matchingParticipant?.FOTO || conversationLogoFromData;



 
  const hasTomador = Boolean(
    stampTomadorFromConversation ||
    participants.some((participant) => participant?.TIPO === "TM")
  );

  const [newMessage, setNewMessage] = useState("");
  const messageInputRef = useRef(null);
  const [mentionQuery, setMentionQuery] = useState("");
  const [showMentionMenu, setShowMentionMenu] = useState(false);
  const messagesEndRef = useRef(null);
  const [typingUsers,setTypingUsers] = useState([]);
  const [botTyping, setBotTyping] = useState(false);
  const socket = useSocket();
  const typingTimeouts = useRef({});
  const [menuOpen, setMenuOpen] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [openModal, setOpenModal] = useState(null);
  const [admin, setAdmin] = useState(null);
  const participantsRef = useRef([]);
  const [toast, setToast] = useState(null);
  const fileInputRef = useRef(null);
  const dragCounterRef = useRef(0);
  const [isDraggingFiles, setIsDraggingFiles] = useState(false);
  const [uploadProgress, setUploadProgress] = useState(0);
  const [uploading, setUploading] = useState(false);
  const menuRef = useRef(null);
  const [loading, setLoading] = useState(false);
  const [hasMore, setHasMore] = useState(true);
  const messagesContainerRef = useRef(null);
  const [showScrollBottom, setShowScrollBottom] = useState(false);
  const [autoScroll, setAutoScroll] = useState(true);
  const autoScrollRef = useRef(true);
  const [loadingMore, setLoadingMore] = useState(false);
  const [sending, setSending] = useState(false);
  const [iaConfigs, setIaConfigs] = useState([]);
  const [currentBotInfo, setCurrentBotInfo] = useState(null);
  const MESSAGE_SOURCE = {
    SOCKET: "socket",
    FETCH: "fetch"
  };


  const getDayKey = (value) => {
    const d = new Date(value);
    if (isNaN(d.getTime())) return "";

    return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
  };

  const conversationName = (() => {
    if (isTemp) return conversationData?.NOME;

    if (!isPrivate) return conversationData?.NOME;

    const otherUser = participants?.find(p => !p.isMe);

    return conversationData?.NOME;
  })();
  const LIMIT = 20;
  const typingAnimationStyle = `
  @keyframes typing {
    0%, 60%, 100% { transform: translateY(0); opacity: 0.3; }
    30% { transform: translateY(-3px); opacity: 1; }
  }
  
  @keyframes slideUp {
    from {
      opacity: 0;
      transform: translateX(-50%) translateY(20px);
    }
    to {
      opacity: 1;
      transform: translateX(-50%) translateY(0);
    }
  }
  `;

  const uiAnimations = `
    /* Animação da indicação visual ao arrastar ficheiros. */
    @keyframes fileDropIn {
      from {
        opacity: 0;
        transform: scale(0.98);
      }
      to {
        opacity: 1;
        transform: scale(1);
      }
    }

    @keyframes fadeInUp {
      from {
        opacity: 0;
        transform: translate(-50%, 10px);
      }
      to {
        opacity: 1;
        transform: translate(-50%, 0);
      }
    }
    `;

const getMessageContent = (msg) => {
  return msg.FILE || msg.CONTEUDO || "";
};

const getMessageStatus = (msg) => {
  if (msg.status) return msg.status;
  if (msg.uploading) return "pending";

  const statusValue =
    msg.status ||
    msg.STATUS ||
    msg.LIDO ||
    msg.lido ||
    msg.read;

  if (typeof statusValue === "string") {
    const lower = statusValue.toLowerCase();
    if (lower === "lido" || lower === "read") return "read";
    if (lower === "enviado" || lower === "sent") return "sent";
    return lower;
  }

  if (statusValue === true) return "read";

  return msg.UTSTP === token ? "sent" : undefined;
};

const formatTermo = (dateString) => {
  if (!dateString) return "";
  const d = new Date(dateString);
  if (isNaN(d.getTime())) return dateString;
  const day = String(d.getDate()).padStart(2, "0");
  const month = String(d.getMonth() + 1).padStart(2, "0");
  const year = d.getFullYear();
  return `${day}-${month}-${year}`;
};

const convertChatEventToSystemMessage = (event) => {
  const userName = event.USER?.NOME || "Sistema";
  switch (event.TIPO) {
    case "participant_added":
      return `${userName} entrou na conversa.`;
    case "participant_removed":
      return `${userName} foi removido(a) do chat.`;
    case "participant_left":
      return `${userName} saiu do chat.`;
    case "participant_promoted":
      return `${userName} foi promovido(a) a administrador.`;
    case "chat_updated":
      return `${userName} atualizou as informações do chat.`;
    default:
      return `${userName} realizou a ação: ${event.TIPO}.`;
  }
};

const formatCurrency = (value) => {
  if (value === null || value === undefined || value === "") return "";

  const numeric = typeof value === "string"
    ? Number(value.replace(/\./g, "").replace(/,/g, ".").replace(/[^0-9.-]/g, ""))
    : Number(value);

  if (Number.isNaN(numeric)) {
    return String(value);
  }

  return numeric.toLocaleString("pt-PT", {
    style: "currency",
    currency: "EUR",
  });
};

const normalizeParticipantName = (value) =>
  String(value || "").trim().toLowerCase();

const getMatchingTomadorItems = (items = []) => {
  if (!Array.isArray(items)) return [];

  return items.filter((item) => {
    const tomador = item?.tomador || item?.Tomador || item?.TOMADOR;
    if (!tomador) return false;

    return participants.some(
      (participant) =>
        normalizeParticipantName(participant?.NOME) === normalizeParticipantName(tomador)
    );
  });
};

const getNoResultsMessage = (type) => {
  if (type === "apolices") {
    return "Não foram encontradas apólices para os participantes associados a este pedido.";
  }

  if (type === "recibos") {
    return "Não foram encontrados recibos para os participantes associados a este pedido.";
  }

  return "Não foram encontrados resultados para os participantes associados a este pedido.";
};

const mentionOptions = iaConfigs.map((ia) => ({
  label: ia.NOME,
  trigger: String(ia.TAG || "").replace(/^@/, ""),
  description: ia.FUNCAO,
  foto: ia.FOTO,
}));

const findBotMention = (message) => {
  const mentionMatch = message.match(/@(\S+)/);
  if (!mentionMatch) return null;
  const trigger = mentionMatch[1].trim().replace(/^@/, "");
  return (
    mentionOptions.find(
      (option) => option.trigger?.toLowerCase() === trigger.toLowerCase()
    ) || null
  );
};

const getFilteredMentionOptions = (query) => {
  const normalized = query.trim().toLowerCase();
  return mentionOptions.filter((option) =>
    option.trigger.toLowerCase().includes(normalized) ||
    option.label.toLowerCase().includes(normalized)
  );
};

const handleSelectMention = (option) => {
  const updated = /@([a-zA-Z]*)?$/.test(newMessage)
    ? newMessage.replace(/@([a-zA-Z]*)?$/, `@${option.trigger} `)
    : `${newMessage.trimEnd()}${newMessage.trim() ? " " : ""}@${option.trigger} `;
  setNewMessage(updated);
  setShowMentionMenu(false);
  setMentionQuery("");
  requestAnimationFrame(() => {
    messageInputRef.current?.focus();
    messageInputRef.current?.setSelectionRange(updated.length, updated.length);
  });
};

const createBotMessage = (text, botInfo = null) => ({
  STAMP: `GemeseIA_${Date.now()}`,
  CONTEUDO: text,
  TIPO: "text",
  nomeUtilizador: botInfo?.label || "Gemese IA",
  DATAENV: new Date(),
  FOTO:
    botInfo?.foto || "https://www.gemese.pt//assets/img/companhias/gemeselogotrans.png",
});

const isAIMessage = (value) => {
  const normalized = String(value || "").toLowerCase().trim();
  return /\b(?:ia|ai)\b/.test(normalized) || normalized.includes("gemese");
};

const addBotParticipant = (botInfo = null) => {
  const name = botInfo?.label || "Gemese IA";
  const exists = participants.find((p) => p.NOME === name);
  if (exists) return;

  const bot = {
    STAMP: `IA_${Date.now()}`,
    NOME: name,
    FOTO:
      botInfo?.foto || "https://www.gemese.pt//assets/img/companhias/gemeselogotrans.png",
    isMe: false,
    isAdmin: false,
  };

  setParticipants((prev) => [...prev, bot]);
};

const sendBotReply = (chatstp, query, botInfo = null) => {
  return new Promise((resolve) => {
    if (!socket) {
      setBotTyping(false);
      resolve(null);
      return;
    }

    setBotTyping(true);

    let finished = false;

    const timeout = setTimeout(() => {
      if (finished) return;
      finished = true;
      setBotTyping(false);
      setCurrentBotInfo(null);
      const fallback = "A IA não respondeu. Tente novamente mais tarde.";
      setMessages((prev) => [...prev, createBotMessage(fallback, botInfo)]);
      socket.off("nova_mensagem", onMessage);
      socket.off("message", onMessage);
      resolve(null);
    }, 15000);

    const onMessage = (msg) => {
      const normalized = {
        STAMP: msg.STAMP || msg.id || `MSG_${Date.now()}`,
        CONTEUDO: msg.CONTEUDO || msg.MENSAGEM || msg.text || "",
        TIPO: (msg.TIPO || "text").toLowerCase(),
        nomeUtilizador: msg.nomeUtilizador || msg.USERNAME || msg.NOME || msg.USER || "IA",
        UTSTP: msg.UTSTP || msg.USER || msg.USERNAME || msg.NOME || null,
        CHATSTP: msg.CHATSTP || msg.chatstp || msg.CHAT || msg.chat || null,
        chatstp: msg.CHATSTP || msg.chatstp || msg.CHAT || msg.chat || null,
        DATAENV: msg.DATAENV || new Date(),
        FILE: msg.FILE || null,
        FILE_NAME: msg.FILE_NAME || null,
        AI_TYPE: msg.AI_TYPE || null,
        DATA: msg.DATA || null
      };

      const belongsToChat =
        normalized.CHATSTP === chatstp ||
        normalized.chatstp === chatstp;

      if (!belongsToChat) return;

      const utstpLower = String(normalized.UTSTP || "").toLowerCase();
      const nomeLower = String(normalized.nomeUtilizador || "").toLowerCase();

      const isAIReply =
        isAIMessage(utstpLower) ||
        isAIMessage(nomeLower) ||
        Boolean(normalized.AI_TYPE) ||
        normalized.TIPO === "bot" ||
        normalized.TIPO === "ai";

      if (isAIReply) {
        if (finished) return;
        finished = true;
        clearTimeout(timeout);
        setBotTyping(false);
        setCurrentBotInfo(null);
        socket.off("nova_mensagem", onMessage);
        socket.off("message", onMessage);
        // A mensagem IA será adicionada pelo handler global `handleIncoming`.
        resolve(normalized.CONTEUDO || null);
      }
    };

    socket.on("nova_mensagem", onMessage);
    socket.on("message", onMessage);

    // Não emitimos `ask_ai` — a IA é disparada pelo envio de `sendMessage` no backend.
  });
};

const showToast = (message) => {
  setToast(message);
  setTimeout(() => setToast(null), 3000);
};



const loadChatData = async (chatstp) => {
  const [msgRes, partRes] = await Promise.all([
    getMessages(chatstp, LIMIT),
    getParticipants(chatstp),
  ]);

  const sorted = msgRes.mensagens.sort(
    (a, b) => new Date(a.DATAENV) - new Date(b.DATAENV)
  );

  setMessages(
    sorted.map((m) => ({
      ...m,
      _source: "fetch",
      status: m.UTSTP === token ? "sent" : undefined,
    }))
  );
  setParticipants(partRes.participantes);
};

// Partilha o envio entre o seletor de ficheiros e o arrastar/largar.
const handleFiles = async (files) => {
  if (!files.length || !socket || sending) return;

  setSending(true);
  let chatstpFinal = conversationId;
  let needsChatCreation = isTemp || !conversationId;

  try {
    for (const file of files) {
      const isImage = file.type.startsWith("image/");
      const isVideo = file.type.startsWith("video/");
      const tipo = isImage ? "image" : isVideo ? "video" : "file";
      let tempId = null;
      let localUrl = null;

      try {
        if (needsChatCreation) {
          chatstpFinal = await new Promise((resolve) => {
            socket.emit(
              "createPrivateChat",
              {
                STAMPTOMADOR: stampTomadorFromConversation,
                STAMPUTILIZADOR: stampUtilizadorFromConversation,
                PARTICIPANTES: ParticipantUtilizador,
                TIPO: "private",
              },
              (res) => resolve(res?.success ? res.chatStamp : null)
            );
          });

          if (!chatstpFinal) {
            showToast("Não foi possível criar a conversa para enviar o ficheiro.");
            break;
          }

          needsChatCreation = false;
          socket.emit("join", chatstpFinal);
          setConversationData((prev) => ({
            ...prev,
            STAMP: chatstpFinal,
            IS_TEMP: false,
          }));
          await loadChatData(chatstpFinal);
        }

        tempId = `TEMP_${Date.now()}_${Math.random().toString(36).slice(2)}`;
        localUrl = URL.createObjectURL(file);
        const me = participants.find((participant) => participant.isMe);

        setMessages((prev) => [
          ...prev,
          {
            STAMP: tempId,
            CONTEUDO: localUrl,
            TIPO: tipo,
            FILE_NAME: file.name,
            nomeUtilizador: "EU",
            DATAENV: new Date().toISOString(),
            uploading: true,
            progress: 0,
            UTSTP: token,
            FOTO: me?.FOTO || null,
            _source: "socket",
          },
        ]);

        const result = await sendFileMessage({
          token,
          chatstp: chatstpFinal,
          file,
          tipo,
          onProgress: (progress) => {
            setMessages((prev) =>
              prev.map((message) =>
                message.STAMP === tempId ? { ...message, progress } : message
              )
            );
          },
        });

        if (!result?.success) {
          setMessages((prev) => prev.filter((message) => message.STAMP !== tempId));
          URL.revokeObjectURL(localUrl);
          showToast(`Não foi possível enviar "${file.name}".`);
          continue;
        }

        setMessages((prev) =>
          prev.map((message) =>
            message.STAMP === tempId
              ? {
                  ...message,
                  uploading: false,
                  progress: 100,
                  status: "sent",
                  STAMP: result.messageId || message.STAMP,
                  CONTEUDO: result.fileLink || message.CONTEUDO,
                  _source: message._source ?? "socket",
                }
              : message
          )
        );
        if (result.fileLink) URL.revokeObjectURL(localUrl);

        socket.emit("sendMessage", {
          chatstp: chatstpFinal,
          TIPO: tipo,
          FILE: result.fileLink,
          MENSAGEM: null,
          STAMP: result.messageId,
          USER: token,
        });
      } catch (uploadError) {
        if (tempId) {
          setMessages((prev) => prev.filter((message) => message.STAMP !== tempId));
        }
        if (localUrl) URL.revokeObjectURL(localUrl);
        showToast(uploadError.message || `Não foi possível enviar "${file.name}".`);
      }
    }
  } finally {
    setSending(false);
  }
};

const handleFileChange = (event) => {
  const files = Array.from(event.target.files || []);
  event.target.value = "";
  handleFiles(files);
};

// Deteta arrastos de ficheiros e apresenta a zona de largada na conversa.
const containsFiles = (event) =>
  Array.from(event.dataTransfer?.types || []).includes("Files");

const handleDragEnter = (event) => {
  if (!containsFiles(event)) return;
  event.preventDefault();
  dragCounterRef.current += 1;
  setIsDraggingFiles(true);
};

const handleDragLeave = (event) => {
  if (!containsFiles(event)) return;
  event.preventDefault();
  dragCounterRef.current = Math.max(0, dragCounterRef.current - 1);
  if (dragCounterRef.current === 0) setIsDraggingFiles(false);
};

const handleDrop = (event) => {
  if (!containsFiles(event)) return;
  event.preventDefault();
  dragCounterRef.current = 0;
  setIsDraggingFiles(false);
  handleFiles(Array.from(event.dataTransfer.files || []));
};

  useEffect(() => {
    const loadIA = async () => {
      try {
        const data = await getIAConfig();
        setIaConfigs(data.ia || []);
      } catch (err) {
        console.error("Erro ao carregar IA:", err);
      }
    };

    loadIA();
  }, [token]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setMenuOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);


 useEffect(() => {
    participantsRef.current = participants;  
  }, [participants]); 


  const handleNewMessage = (msg) => {
     const belongsToChat =
        msg.chatstp === conversationId ||
        msg.CHATSTP === conversationId;

     if (!belongsToChat) return;
   
    const sender = participants.find(
      (p) => p.STAMP === msg.UTSTP || p.NOME === msg.nomeUtilizador
    );

  const profilePhoto = sender?.FOTO
    ? `data:image/jpeg;base64,${arrayBufferToBase64(sender.FOTO.data)}`
    : null;  



  const msgWithPhoto = {
        ...msg,
        FOTO: profilePhoto,
        DATAENV: msg.DATAENV || new Date().toISOString()
    };

    setMessages((prev) => [...prev, msgWithPhoto]);
  };

 


useEffect(() => {
  setMessages([]);
  setHasMore(true);
  setLoading(false);
}, [conversationId]);



 const leaveChat = async () => {
  if (!socket || !conversationId) return;

  if (admin?.isAdmin) {
    const otherAdmins = participants.filter(p => p.isAdmin && !p.isMe);
    const isAlone = participants.length === 1 && participants[0].isMe;
    
    if (otherAdmins.length === 0 && !isAlone && messages.length > 0) {
      showToast("Você é o único administrador. Promova outro admin antes de sair.");
      return;
    }
  }

  socket.emit("userLeftChat", { chatstp: conversationId });

  setMessages([]);
  setParticipants([]);
  if (onBack) onBack();
};



 const fetchMessages = async (before = null) => {


    if (!conversationId) return;

    if (before) setLoadingMore(true);
    else setLoading(true);

    try {
      const container = messagesContainerRef.current;
      if (!container) return;

      const prevScrollHeight = container.scrollHeight;
      const prevScrollTop = container.scrollTop;

      const data = await getMessages(conversationId, LIMIT, before);

      const sorted = data.mensagens.sort(
        (a, b) => new Date(a.DATAENV) - new Date(b.DATAENV)
      );

      setMessages((prev) =>
        before ? [...sorted, ...prev] : sorted
      );

      requestAnimationFrame(() => {
        if (!before) {
          container.scrollTop = container.scrollHeight;
          return;
        }

        const newScrollHeight = container.scrollHeight;

        container.scrollTop =
          newScrollHeight - prevScrollHeight + prevScrollTop;
      });

      if (data.mensagens.length < LIMIT) {
        setHasMore(false);
      }

    } finally {
      setLoading(false);
      setLoadingMore(false);
    }
  };

  const handleScroll = () => {
    const container = messagesContainerRef.current;
    if (!container) return;

    const distanceFromBottom =
      container.scrollHeight - container.scrollTop - container.clientHeight;

    const isAtBottom = distanceFromBottom < 120;

    setAutoScroll(isAtBottom);
    autoScrollRef.current = isAtBottom;
    setShowScrollBottom(!isAtBottom);

    const isNearTop = container.scrollTop <= 10;
    const isLoading = loading || loadingMore;
    if (isNearTop && hasMore && !isLoading) {
      const firstDate = messages?.[0]?.DATAENV;
      if (firstDate) {
        fetchMessages(new Date(firstDate).toISOString());
      }
    }
  };


  const fetchParticipants = async () => {
      try {
        const data = await getParticipants(conversationId);
        setParticipants(data.participantes);
        const meAdmin = data.participantes.find(
            p => p.isMe && p.isAdmin
          );

        setAdmin(meAdmin || null);
       
  
      } catch (err) {
        console.error("Erro ao buscar participantes:", err);
      }
    };

   const handleOpenAddParticipant = async () => {
        if (participants.length > 0) {
          setOpenModal("addParticipant"); 
          setMenuOpen(false);
        } else {
          await fetchParticipants();     
          setOpenModal("addParticipant");
          setMenuOpen(false);
        }
   };

  const handleOpenGroupDetails = () => {

      setOpenModal("groupDetails");
      setMenuOpen(false);
  };


  useEffect(() => {
      const container = messagesContainerRef.current;
      if (!container) return;

      const isNewConversation = messages.length === 0;

      if (isNewConversation) {
        container.scrollTop = 0;
        return;
      }

      const isAtBottom =
        container.scrollHeight - container.scrollTop - container.clientHeight < 120;

      if (isAtBottom) {
        container.scrollTop = container.scrollHeight;
      }
  }, [messages, conversationId]);


  useEffect(() => {
      const container = messagesContainerRef.current;
      if (!container) return;

      if (autoScroll) {
        container.scrollTop = container.scrollHeight;
      }
  }, [messages]);


  useEffect(() => {
  if (!socket || !conversationId) return;

  const handleParticipantsResult = (data) => {
    if (!data) return;
    if (data.chatstp && data.chatstp !== conversationId) return;

   
    fetchParticipants();
  };

  socket.on("participantsResult", handleParticipantsResult);

  return () => {
    socket.off("participantsResult", handleParticipantsResult);
  };
}, [socket, conversationId]);


useEffect(() => {
  if (!socket || !conversationId || !token) return;

  if (isTemp) {
    setMessages([]);

    setParticipants([
      {
        STAMP:
          stampTomadorFromConversation ||
          stampUtilizadorFromConversation,
        NOME: conversationName,
        FOTO: conversationLogo,
        TIPO: stampTomadorFromConversation ? "TM" : "UTL",
        isMe: false,
      },
    ]);

    

    return;
  }

  let cancelled = false;

  const loadChat = async () => {
    setLoading(true);

    try {
      socket.emit("join", conversationId);
      
      const [msgRes, partRes] = await Promise.all([
        getMessages(conversationId, LIMIT),
        getParticipants(conversationId),
      ]);

      if (cancelled) return;

      const sorted = msgRes.mensagens.sort(
        (a, b) => new Date(a.DATAENV) - new Date(b.DATAENV)
      );

      setMessages(
        sorted.map((m) => {
          const sender = partRes.participantes.find(
            (participant) =>
              participant.STAMP === m.UTSTP ||
              participant.NOME === m.nomeUtilizador
          );

         const profilePhoto = m?.FOTO
                      ? (m.FOTO.startsWith('data:image/')
                          ? m.FOTO
                          : `data:image/jpeg;base64,${m.FOTO}`)
                      : sender?.FOTO || null;
      

          return {
            ...m,
            FOTO: profilePhoto,
            status:
              m.status ||
              m.STATUS ||
              (m.LIDO || m.lido || m.read ? "read" : undefined) ||
              (m.UTSTP === token ? "sent" : undefined),
          };
        })
      );
      setParticipants(partRes.participantes);

      const meAdmin = partRes.participantes.find(
        p => p.isMe && p.isAdmin
      );

      setAdmin(meAdmin || null);

    } catch (err) {
      console.error(err);
    } finally {
      if (!cancelled) setLoading(false);
    }
  };

  loadChat();

  return () => {
    cancelled = true;
  };
}, [
  conversationId,
  socket,
  token,
  isTemp,
  conversationName,
  conversationLogo,
]);

useEffect(() => {
  if (!socket || !conversationId) return;

 


    const normalizeMessage = (msg) => {
      return {
        STAMP: msg.STAMP || msg.id || `MSG_${Date.now()}`,
        CONTEUDO: msg.CONTEUDO || msg.MENSAGEM || msg.text || "",
        TIPO: (msg.TIPO || "text").toLowerCase(),
        nomeUtilizador: msg.nomeUtilizador || msg.USERNAME || "IA",
        UTSTP: msg.UTSTP || null,
        CHATSTP: msg.CHATSTP || msg.chatstp,
        DATAENV: msg.DATAENV,
        FILE: msg.FILE || null,
        FILE_NAME: msg.FILE_NAME || null,
        AI_TYPE: msg.AI_TYPE || null,
        DATA: msg.DATA || null,
        status:
          msg.status ||
          msg.STATUS ||
          (msg.LIDO || msg.lido || msg.read ? "read" : undefined),
      };
    };  


  const handleIncoming = (msg) => {

    const normalized = normalizeMessage(msg);

    const belongsToChat =
        normalized.CHATSTP === conversationId ||
        normalized.chatstp === conversationId;

    if (!belongsToChat) return;
    
    const utstpLower = String(normalized.UTSTP || "").toLowerCase();
    const nomeLower = String(normalized.nomeUtilizador || "").toLowerCase();
    const isAIReply =
      isAIMessage(utstpLower) ||
      isAIMessage(nomeLower) ||
      Boolean(normalized.AI_TYPE) ||
      normalized.TIPO === "bot" ||
      normalized.TIPO === "ai";

    if (isAIReply) {
      setBotTyping(false);
      setCurrentBotInfo(null);
    }

    console.log("TESTE " + normalized.CONTEUDO);  

    setMessages((prev) => {
      const alreadyExists = prev.some(m => m.STAMP === normalized.STAMP);
      if (alreadyExists) return prev;
 
      const profilePhoto = normalized.FOTO?.data
        ? `data:image/jpeg;base64,${arrayBufferToBase64(normalized.FOTO.data)}`
        : normalized.FOTO || null;

      


      return [
        ...prev,
        {
          ...normalized,
          FOTO: profilePhoto,
          _source: "socket",
        },
      ];
    });
  };

  const handleChatEvent = (event) => {
    if (!conversationId) return;
    const systemMessage = {
      STAMP: `SYS_${Date.now()}_${event.TIPO}`,
      CONTEUDO: convertChatEventToSystemMessage(event),
      TIPO: "system",
      nomeUtilizador: "Sistema",
      UTSTP: "SYSTEM",
      CHATSTP: conversationId,
      DATAENV: event.DATAENV || new Date().toISOString(),
      EVENT: event.TIPO,
    };
    setMessages((prev) => [...prev, systemMessage]);
  };

  socket.on("nova_mensagem", handleIncoming);
  socket.on("chat_event", handleChatEvent);

  return () => {
    socket.off("nova_mensagem", handleIncoming);
    socket.off("message", handleIncoming);
    socket.off("chat_event", handleChatEvent);
  };
}, [socket, conversationId]);

useEffect(() => {
  if (!socket || !conversationId) return;


 const handleTyping = ({ user,chatstp }) => {
    if (chatstp !== conversationId) return;

    const currentParticipants = participantsRef.current;
    if (!currentParticipants?.length) return;

    const participant = currentParticipants.find(
      p =>
        p.NOME?.trim().toLowerCase() ===
        user.nome?.trim().toLowerCase()
    );

    const userPhoto = participant?.FOTO || null;

    setTypingUsers((prev) => {
      const filtered = prev.filter((u) => u.nome !== user.nome);

      return [
        ...filtered,
        {
          ...user,
          FOTO: userPhoto,
          ts: Date.now()
        }
      ];
    });

    if (typingTimeouts.current[user.nome]) {
      clearTimeout(typingTimeouts.current[user.nome]);
    }

    typingTimeouts.current[user.nome] = setTimeout(() => {
      setTypingUsers((prev) =>
        prev.filter((u) => u.nome !== user.nome)
      );
      delete typingTimeouts.current[user.nome];
    }, 3000);
  };

  socket.on("typing", handleTyping);

  return () => {
    socket.off("typing", handleTyping);
  };
}, [socket, conversationId]);


useEffect(() => {
  if (!socket) return;

  const handleCreateChat = (data) => {
    if (!data?.success) return;

    const chatStamp =
      data?.CHATSTP ||
      data?.chatStamp ||
      data?.chatstp ||
      data?.STAMP ||
      null;

    const publicId =
      data?.PUBLIC_ID ||
      data?.publicId ||
      data?.public_id ||
      null;

    const nextConversation = {
      ...(conversationData || {}),
      STAMP: chatStamp,
      NOME: data?.NOME || conversationData?.NOME || "Novo Chat",
      LOGO: data?.LOGO || conversationData?.LOGO || null,
      PUBLIC_ID: publicId,
      IS_TEMP: false,
    };

    setSelectedConversation(nextConversation);
    setConversationData?.(nextConversation);

   

    if (publicId || chatStamp) {
      navigate(`/conversas/${publicId || chatStamp}`);
    }
  };

  socket.on("createChatResult", handleCreateChat);

  return () => {
    socket.off("createChatResult", handleCreateChat);
  };
}, [socket, setSelectedConversation, setConversationData, conversationData, navigate]);

 const sendMessage = async () => {
  if (!newMessage.trim() || !socket || sending) return;

  setSending(true);

  try {
    const me = participants.find(p => p.isMe);
    const myPhoto = me?.FOTO ? me.FOTO : null;

    let chatstpFinal = conversationId;
    let publicIdFinal = conversationData?.PUBLIC_ID || null;

    if (isTemp) {
     let resultado = await new Promise((resolve) => {
        socket.emit(
          "createPrivateChat",
          {
            STAMPTOMADOR: stampTomadorFromConversation,
            STAMPUTILIZADOR: stampUtilizadorFromConversation,
            PARTICIPANTES: ParticipantUtilizador,
            TIPO: "private",
            NOMETOMADOR: conversationData?.NOME
          },
          (res) => resolve(res?.success ? res : null)
        );
      });

  

     chatstpFinal = resultado.chatStamp;
     publicIdFinal = resultado?.PUBLIC_ID || null;

  
     if (!chatstpFinal) return;

      
      setConversationData((prev) => ({
        ...prev,
        STAMP: chatstpFinal,
        PUBLIC_ID: publicIdFinal,
        IS_TEMP: false,
      }));

      await loadChatData(chatstpFinal);

      if (typeof refreshChats === "function") {
          await refreshChats(newMessage, publicIdFinal);
      }

      /*
      setSelectedConversation((prev) => ({
        ...(prev || {}),
        STAMP: chatstpFinal,
        PUBLIC_ID: publicIdFinal,
        IS_TEMP: false,
        ULTMSG : newMessage
      }));
      */
    }

    const message = newMessage;
    const botMention = findBotMention(message);
    const botQuery = /@\S+/.test(message)
      ? message.replace(/@\S+/g, "").trim()
      : null;

    setNewMessage(""); 

    const tempId = `ME_TEMP_${Date.now()}`;

    setMessages((prev) => [
      ...prev,
      {
        STAMP: tempId,
        PUBLIC_ID: publicIdFinal,
        CONTEUDO: message,
        TIPO: "text",
        nomeUtilizador: "EU",
        DATAENV: new Date().toISOString(),
        UTSTP: token,
        FOTO: myPhoto,
        _source: "socket",
        status: "pending",
      },
    ]);

    const botInfo = botMention || null;
    let botReplyPromise = null;
    if (botQuery !== null) {
      addBotParticipant(botInfo);
      setCurrentBotInfo(botInfo);
      botReplyPromise = sendBotReply(chatstpFinal, botQuery, botInfo);
    }


    socket.emit(
      "sendMessage",
      {
        chatstp: chatstpFinal,
        MENSAGEM: message,
        PUBLIC_ID: publicIdFinal,
        TIPO: "text",
        TIPOCHAT: isPrivate ? "private" : "group",
        PARTICIPANTES: participants.map((p) => p.STAMP || p.NOME)
      
      },
      (response) => {
        setMessages((prev) =>
          prev.map((m) =>
            m.STAMP === tempId
              ? {
                  ...m,
                  status: response?.success || response?.messageId ? "sent" : "failed",
                  STAMP: response?.messageId || m.STAMP,
                }
              : m
          )
        );
      }
    );

    if (botReplyPromise) {
      setSending(false);
      await botReplyPromise;
    }

  } finally {
    setSending(false);
  }
};

  const scrollToBottom = () => {
    const container = messagesContainerRef.current;
    if (!container) return;

    container.scrollTo({
      top: container.scrollHeight,
      behavior: "smooth",
    });
  };



  const maxVisibleParticipants = isMobile ? 4 : 6;
  const participantCount = participants.length;
  const extraParticipants = Math.max(0, participantCount - maxVisibleParticipants);
  const visibleParticipants =
    extraParticipants > 0
      ? participants.slice(0, maxVisibleParticipants)
      : participants;

  if (!conversationId && !isTemp)
    return <div style={styles.emptyState}></div>;

  return (
   <div
      style={styles.container(isMobile)}
      onDragEnter={handleDragEnter}
      onDragOver={(event) => {
        if (containsFiles(event)) event.preventDefault();
      }}
      onDragLeave={handleDragLeave}
      onDrop={handleDrop}
    >
      {isDraggingFiles && (
        <div style={styles.fileDropOverlay} aria-hidden="true">
          Largue os ficheiros para os enviar
        </div>
      )}
      {loading && (
        <div style={styles.loadingOverlay}>
        <div style={styles.spinner} />
        </div>
    )}  
      <style>{typingAnimationStyle + uiAnimations}</style>
      <div style={styles.header}>

        {/* Toast */}
        {toast && (
          <div style={styles.toast}>
            {toast}
          </div>
        )}

       
        {/* 🔹 LINHA 1 (nome + botão) */}
        <div style={styles.headerTop(isMobile)}>
           {isMobile && (
              <button
                onClick={onBack}
                style={styles.backButton}
              >
                <IoChevronBackCircle size={28} color="rgb(31, 58, 112)" />
              </button>
            )}

            {/* ESQUERDA */}
            <div style={styles.headerLeft(isMobile)}>
              {conversationLogo ? (
                <img
                  src={conversationLogo}
                  alt={conversationName}
                  style={styles.conversationLogo}
                />
              ) : (
                <div style={styles.conversationPlaceholder}>
                  <MdGroup size={isMobile ? 20 : 24} color="#666" />
                </div>
              )}
              <h2 style={styles.h2(isMobile)}>{conversationName}</h2>
            </div>

                {/*  BOTÃO 3 PONTOS */}
                {!isTemp &&(
                <div style={styles.menuContainer} ref={menuRef}>
                  <button
                    onClick={(e) => {
                      e.stopPropagation();
                      setMenuOpen(!menuOpen);
                    }}
                    style={styles.headerMenuButton}
                  >
                    <IoEllipsisVertical size={22} color="rgb(31, 58, 112)" />
                  </button>

                  {/* MENU */}
                  {menuOpen && (
                    <div style={styles.menuDropdown}>

                   {(
                      (admin?.isAdmin && hasTomador) ||
                      (admin?.isAdmin && !hasTomador && !isPrivate)
                    ) && (
                        <div
                            onMouseDown={() => {
                                handleOpenAddParticipant()
                            }}
                            style={styles.menuItemOption}
                            onMouseEnter={(e) => (e.currentTarget.style.background = "#f5f5f5")}
                            onMouseLeave={(e) => (e.currentTarget.style.background = "transparent")}
                          >
                            <FaUserPlus size={18} />  
                            Adicionar elemento
                        </div>
                    )}

                      <div
                          onClick={() => {
                               handleOpenGroupDetails ()
                          }}
                          style={styles.menuItemOption}
                          onMouseEnter={(e) => (e.currentTarget.style.background = "#f5f5f5")}
                          onMouseLeave={(e) => (e.currentTarget.style.background = "transparent")}
                        >
                          <FaUserGroup size={18} />  
                          Detalhes
                      </div>


                       {(
                          (admin?.isAdmin && hasTomador) ||
                          (admin?.isAdmin && !hasTomador && !isPrivate)
                        ) && (
                        <div
                          onClick={() => {
                            leaveChat();
                          }}
                          style={styles.menuItemOption}
                          onMouseEnter={(e) =>
                            (e.currentTarget.style.background = "#f5f5f5")
                          }
                          onMouseLeave={(e) =>
                            (e.currentTarget.style.background = "transparent")
                          }
                        >
                          <HiOutlineLogout size={18} />
                          Sair do grupo
                        </div>
                      )}

                    </div>
                  )}
                </div>
                )}
              </div>

              {/* 🔹 LINHA 2 (participantes) */}
              {!(isPrivate && isTemp) && (
              <div style={styles.participantsContainer(isMobile)}>
                {visibleParticipants.map((p) => (
                  <div
                    key={p.STAMP || p.NOME}
                    style={styles.participantItem(isMobile)}
                  >
                    <div style={styles.participantAvatarWrapper}>
                      <div style={styles.participantAvatar(p.isMe)}>
                        {p.FOTO ? (
                          <img
                            src={p.FOTO}
                            alt={p.NOME}
                            style={{
                              width: "100%",
                              height: "100%",
                              objectFit: "cover",
                            }}
                          />
                        ) : p.TIPO === "TM" ? (
                          <FaUserShield size={isMobile ? 16 : 16} color="#fff" />
                        ) : (
                          <FaUser size={isMobile ? 16 : 16} color="#fff" />
                        )}
                      </div>

                      {p.isAdmin && (
                        <FaCrown
                          size={10}
                          color="#FFD700"
                          style={styles.crownIcon}
                        />
                      )}
                    </div>

                    <span style={styles.participantName}>{p.NOME}</span>
                  </div>
                ))}

                {extraParticipants > 0 && (
                  <div style={styles.participantExtraBadge(isMobile)}>
                    +{extraParticipants}
                  </div>
                )}
              </div>
              )}
         </div>

      <div style={styles.messagesContainer} ref={messagesContainerRef} onScroll={handleScroll}>

           {loadingMore && (
              <div style={styles.loadMoreContainer}>
                <div style={styles.spinnerSmall} />
              </div>
           )}  


          {messages.map((msg,index) => {
            const sender = msg.nomeUtilizador?.trim() === "EU" ? "EU" : "";
            const currentUserPhoto =
              participants.find(
                (p) =>
                  p.isMe ||
                  p.STAMP === token ||
                  p.UTSTP === token ||
                  p.STAMP === localStorage.getItem("token")
              )?.FOTO ||
              participants.find((p) => p.STAMP === msg.UTSTP && p.isMe)?.FOTO ||
              null;

            const profilePhoto =
              msg.FOTO ||
              (msg.UTSTP === token
                ? currentUserPhoto || conversationData?.FOTO || null
                : participants.find(
                    (p) =>
                      p.STAMP === msg.UTSTP ||
                      p.NOME === msg.nomeUtilizador ||
                      p.NOME === msg.nomeTomador
                  )?.FOTO || null);
            const prevMsg = messages[index - 1];
            const tipo_utilizador = msg.nomeUtilizador ? "UTL" : "TM";
            const isSystemMessage = msg.TIPO === "system" || msg.UTSTP === "SYSTEM";
            const showDaySeparator =
            !prevMsg ||
            getDayKey(prevMsg.DATAENV) !== getDayKey(msg.DATAENV);

           if (isSystemMessage) {
             return (
               <React.Fragment key={`${conversationId}_${msg.STAMP}_${index}`}>
                 {showDaySeparator && <DaySeparator date={msg.DATAENV} />}
                 <div style={styles.systemMessageWrapper}>
                   <div style={styles.systemMessageBubble}>
                     <p style={styles.systemMessageText}>{msg.CONTEUDO}</p>
                     <small style={styles.systemMessageTime}>
                       {formatDate(msg.DATAENV, msg._source)}
                     </small>
                   </div>
                 </div>
               </React.Fragment>
             );
           }

           return (
                <React.Fragment key={`${conversationId}_${msg.STAMP}_${index}`}>
                  {showDaySeparator && <DaySeparator date={msg.DATAENV} />}

                  <div
                     style={sender === "EU" ? styles.messageContainerReverse : styles.messageContainer}
                  >
                    {/* Foto ou ícone */}
                    {profilePhoto ? (
                      <img
                        src={profilePhoto}
                        alt="avatar"
                        style={{
                          ...styles.messageAvatar,
                          marginRight: sender === "EU" ? 0 : 8,
                          marginLeft: sender === "EU" ? 8 : 0,
                        }}
                      />
                    ) : (
                      <div
                        style={{
                          ...styles.messageAvatarPlaceholder,
                          marginRight: sender === "EU" ? 0 : 8,
                          marginLeft: sender === "EU" ? 8 : 0,
                        }}
                      >
                      
                      {tipo_utilizador === "TM" ? (
                          <FaUserShield size={isMobile ? 16 : 20} color="#fff" />
                      ) : (
                          <FaUser size={isMobile ? 16 : 20} color="#fff" />
                      )}

                      </div>
                    )}

                    {/* Bubble da mensagem */}
                    <div style={styles.message(sender)}>
                      <div style={styles.messageBubble(sender)}>
                        <strong style={styles.messageUser(sender)}>
                          {msg.nomeUtilizador?.trim() || msg.nomeTomador || "Admin"}
                        </strong>
                       {(!msg.AI_TYPE || typeof msg.CONTEUDO === "string") && !msg.CONTEUDO?.type && ["text", "image", "video"].includes(msg.TIPO?.toLowerCase()) ? (
                          <>
                            {msg.TIPO.toLowerCase() === "text" && (
                              <p style={styles.messageText}>{getMessageContent(msg)}</p>
                            )}

                            {msg.TIPO.toLowerCase() === "image" && (
                              <img
                                src={getMessageContent(msg)}
                                alt="imagem"
                                style={styles.imageMessage}
                              />
                            )}

                            {msg.TIPO.toLowerCase() === "video" && (
                              <video
                                src={getMessageContent(msg)}
                                controls
                                style={styles.videoMessage}
                              />
                            )}
                          </>
                        ) : !msg.AI_TYPE && !msg.CONTEUDO?.type ? (
                          <a
                            href={getMessageContent(msg)}
                            target="_blank"
                            rel="noreferrer"
                            style={styles.fileAttachment}
                          >
                            <div style={styles.fileMetaContainer}>
                              <FaPaperclip size={14} color="#6b7280" />
                              <span style={styles.fileName}>
                                {msg.FILE_NAME || "Ficheiro"}
                              </span>
                            </div>
                           
                          </a>
                        ) : null}

                        {msg.AI_TYPE === "apolices" && (
                          <div style={styles.apolicesContainer}>
                            <div style={styles.apolicesHeader}>
                              📄 <strong>Apólices encontradas</strong>
                            </div>

                            {(() => {
                              const matchingApolices = getMatchingTomadorItems(msg.DATA?.apolices);

                              if (matchingApolices.length === 0) {
                                return <p style={styles.messageText}>{getNoResultsMessage("apolices")}</p>;
                              }

                              return (
                                <>
                                  <table style={styles.apolicesTable}>
                                    <thead>
                                      <tr style={styles.apolicesTableHeader}>
                                        <th style={styles.apolicesTableCell}>Apólice</th>
                                        <th style={styles.apolicesTableCell}>Início</th>
                                        <th style={styles.apolicesTableCell}>Tomador</th>
                                        <th style={styles.apolicesTableCell}>Companhia</th>
                                        <th style={styles.apolicesTableCell}>Termo</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {matchingApolices.map((a, i) => (
                                        <tr key={i} style={styles.apolicesTableRow(i % 2 === 0)}>
                                          <td style={styles.apolicesTableCell}>{a.apolice}</td>
                                          <td style={styles.apolicesTableCell}>{formatTermo(a.inicio)}</td>
                                          <td style={styles.apolicesTableCell}>{a.tomador}</td>
                                          <td style={styles.apolicesTableCell}>{a.companhia}</td>
                                          <td style={styles.apolicesTableCellLast}>{formatTermo(a.termo)}</td>
                                        </tr>
                                      ))}
                                    </tbody>
                                  </table>

                                  <div style={styles.apolicesFooter}>
                                    Total: <strong>{matchingApolices.length}</strong>
                                  </div>
                                </>
                              );
                            })()}
                          </div>
                        )}

                        {msg.AI_TYPE === "recibos" && (
                          <div style={styles.apolicesContainer}>
                            <div style={styles.apolicesHeader}>
                              📄 <strong>Recibos encontrados</strong>
                            </div>

                            {(() => {
                              const matchingRecibos = getMatchingTomadorItems(msg.DATA?.recibos);

                              if (matchingRecibos.length === 0) {
                                return <p style={styles.messageText}>{getNoResultsMessage("recibos")}</p>;
                              }

                              return (
                                <>
                                  <table style={styles.apolicesTable}>
                                    <thead>
                                      <tr style={styles.apolicesTableHeader}>
                                        <th style={styles.apolicesTableCell}>Recibo</th>
                                        <th style={styles.apolicesTableCell}>Limite Pag.</th>
                                        <th style={styles.apolicesTableCell}>Apólice</th>
                                        <th style={styles.apolicesTableCellValue}>Valor</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {matchingRecibos.map((r, i) => (
                                        <tr key={i} style={styles.apolicesTableRow(i % 2 === 0)}>
                                          <td style={styles.apolicesTableCell}>{r.numero || r.recibo}</td>
                                          <td style={styles.apolicesTableCell}>{formatTermo(r.dataAnulacao)}</td>
                                          <td style={styles.apolicesTableCellLast}>{r.apolice}</td>
                                          <td style={styles.apolicesTableCellValue}>{formatCurrency(r.valor)}</td>
                                        </tr>
                                      ))}
                                    </tbody>
                                  </table>

                                  <div style={styles.apolicesFooter}>
                                    Total: <strong>{formatCurrency(matchingRecibos.reduce((sum, item) => sum + Number(item?.valor || 0), 0))}</strong>
                                  </div>
                                </>
                              );
                            })()}
                          </div>
                        )}

                        {msg.CONTEUDO?.type === "recibos" && (
                          <div style={styles.apolicesContainer}>
                            <div style={styles.apolicesHeader}>
                              📄 <strong>{msg.CONTEUDO.message || "Recibos encontrados"}</strong>
                            </div>

                            {(() => {
                              const matchingRecibos = getMatchingTomadorItems(msg.CONTEUDO.data?.recibos || []);

                              if (msg.CONTEUDO.data?.recibos && msg.CONTEUDO.data.recibos.length > 0) {
                                if (matchingRecibos.length === 0) {
                                  return <p style={styles.messageText}>{getNoResultsMessage("recibos")}</p>;
                                }

                                return (
                                  <>
                                    <table style={styles.apolicesTable}>
                                      <thead>
                                        <tr style={styles.apolicesTableHeader}>
                                          <th style={styles.apolicesTableCell}>Recibo</th>
                                          <th style={styles.apolicesTableCell}>Limite Pag.</th>
                                          <th style={styles.apolicesTableCell}>Tomador</th>
                                          <th style={styles.apolicesTableCell}>Apólice</th>
                                          <th style={styles.apolicesTableCellValue}>Valor</th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        {matchingRecibos.map((r, i) => (
                                          <tr key={i} style={styles.apolicesTableRow(i % 2 === 0)}>
                                            <td style={styles.apolicesTableCell}>{r.numero || r.recibo}</td>
                                            <td style={styles.apolicesTableCell}>{formatTermo(r.dataAnulacao)}</td>
                                            <td style={styles.apolicesTableCell}>{r.tomador}</td>
                                            <td style={styles.apolicesTableCellLast}>{r.apolice}</td>
                                            <td style={styles.apolicesTableCellValue}>{formatCurrency(r.valor)}</td>
                                          </tr>
                                        ))}
                                      </tbody>
                                    </table>

                                    <div style={styles.apolicesFooter}>
                                      Total: <strong>{formatCurrency(matchingRecibos.reduce((sum, item) => sum + Number(item?.valor || 0), 0))}</strong>
                                    </div>
                                  </>
                                );
                              }

                              return <p style={styles.messageText}>{msg.CONTEUDO.message}</p>;
                            })()}
                          </div>
                        )}

                        {msg.uploading && (
                          <div style={styles.progressBarContainer}>
                            <div
                              style={styles.progressBar(msg.progress)}
                            />
                          </div>
                        )}

                        <div style={styles.messageMeta}>
                          <small
                            style={{
                              ...styles.messageTime,
                              color: sender === "EU" ? "#fff" : "#666",
                            }}
                          >
                            {formatDate(msg.DATAENV, msg._source)}
                          </small>
                          {sender === "EU" && (
                            <span style={styles.messageStatusIcon}>
                              {getMessageStatus(msg) === "pending" ? (
                                <FaCheck style={{ color: "#fff", fontSize: 12 }} />
                              ) : (
                                <FaCheckDouble
                                  style={{
                                    color:
                                      getMessageStatus(msg) === "read"
                                        ? "#3b82f6"
                                        : "rgba(255,255,255,0.85)",
                                    fontSize: 12,
                                  }}
                                />
                              )}
                            </span>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </React.Fragment>
              );
          })}

           {typingUsers.map((u) => (
              <div
                key={u.nome}
                style={{
                  display: "flex",
                  marginBottom: 10,
                  flexDirection: "row", 
                  alignItems: "flex-start",
                }}
              >
                {/* Foto do utilizador */}
                <div style={{ width: 40, height: 40, borderRadius: "50%", marginRight: 8 }}>
                  {u.FOTO ? (
                    <img
                      src={u.FOTO}
                      alt={u.nome}
                      style={{ width: "100%", height: "100%", objectFit: "cover", borderRadius: "50%" }}
                    />
                  ) : (

                    <div 
                      style={
                        {
                          width: 40,
                          height: 40,
                          borderRadius: "50%",
                          backgroundColor: "#ccc",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          flexShrink: 0,
                          overflow: "hidden",
                        }
                      }>
                        <FaUser size={isMobile ? 16 : 20} color="#fff"  />
                    </div>
                  
                  )}
               </div>

                {/* Bolha de typing */}
                <TypingIndicator isMe={false} />
              </div>
            ))}

            {botTyping && (
              <div
                style={{
                  display: "flex",
                  marginBottom: 10,
                  flexDirection: "row",
                  alignItems: "flex-start",
                }}
              >
                <div
                  style={{
                    width: 40,
                    height: 40,
                    borderRadius: "50%",
                    marginRight: 8,
                    overflow: "hidden",
                  }}
                >
                  <img
                    src={currentBotInfo?.foto || "https://www.gemese.pt//assets/img/companhias/gemeselogotrans.png"}
                    alt={currentBotInfo?.label || "Gemese IA"}
                    style={{ width: "100%", height: "100%", objectFit: "cover" }}
                  />
                </div>
                <div style={{ display: "flex", flexDirection: "column", gap: 4 }}>
                  <span style={{ fontSize: 12, color: "#6b7280", fontWeight: 600 }}>
                    {currentBotInfo?.label || "Gemese IA"} está a escrever...
                  </span>
                  <TypingIndicator isMe={false} />
                </div>
              </div>
            )}
       </div>

       {showScrollBottom && (
        <div style={styles.scrollButtonWrapper(isMobile)}>
          <button
            onClick={scrollToBottom}
            style={styles.scrollBottomButton}
          >
            <VscArrowDown size={18}/>
          </button>
        </div>
      )}

      

      <div style={styles.inputContainer(isMobile)}>
        <button
          onClick={() => fileInputRef.current.click()}
          style={styles.attachButton}
          type="button"
          aria-label="Anexar ficheiro"
          title="Anexar ficheiro"
        >
          <FaPaperclip size={20} color="#666" />
        </button>    

        <input
          type="text"
          ref={messageInputRef}
          value={newMessage}
          onChange={(e) => {
             const value = e.target.value;
             setNewMessage(value);

             const mentionMatch = value.match(/@([a-zA-Z]*)$/);
             if (mentionMatch) {
               setMentionQuery(mentionMatch[1] || "");
               setShowMentionMenu(true);
             } else {
               setMentionQuery("");
               setShowMentionMenu(false);
             }

             if(socket){
                socket.emit("typing",{chatstp: conversationId});
             }

          }}
          onKeyPress={(e) => e.key === "Enter" && sendMessage()}
          placeholder="Digite uma mensagem... Use @gemese para acionar a Gemese IA"
          style={styles.input}
        />
        {showMentionMenu && (
          <div style={styles.mentionMenu}>
            {getFilteredMentionOptions(mentionQuery).length > 0
              ? getFilteredMentionOptions(mentionQuery).map((option) => (
              <div
                key={option.trigger}
                style={styles.mentionItem}
                onMouseDown={(event) => {
                  event.preventDefault();
                  handleSelectMention(option);
                }}
              >
                <div style={styles.mentionAvatarWrapper}>
                  <img
                    src={option.foto}
                    alt={option.label}
                    style={styles.mentionAvatar}
                  />
                </div>
                <div style={{ display: "flex", flexDirection: "column" }}>
                  <strong>{option.label}</strong>
                  <span style={styles.mentionDescription}>{option.trigger}</span>
                </div>
              </div>
              ))
              : <div style={styles.mentionEmpty}>Não há IAs disponíveis.</div>}
          </div>
        )}
       <button
          type="button"
          onClick={() => {
            setMentionQuery("");
            setShowMentionMenu((isOpen) => !isOpen);
          }}
          style={styles.aiCallButton}
          aria-label="Chamar IA"
          title="Chamar IA"
          aria-expanded={showMentionMenu}
        >
          <MdAutoAwesome size={20} />
        </button>
       <button onClick={sendMessage} style={styles.sendButton} disabled={sending} aria-label="Enviar mensagem" title="Enviar mensagem">
          {sending ? (
            <div style={{ width: 16, height: 16, border: "2px solid #fff", borderTop: "2px solid transparent", borderRadius: "50%", animation: "spin 0.8s linear infinite" }} />
          ) : (
            <MdSend size={20} />
          )}
       </button>
      </div>

      <AddParticipantModal
            isOpen={openModal === "addParticipant"}
            onClose={() => setOpenModal(false)}
            participants={participants}
            isMobile={isMobile}
            socket={socket}
            onAddSelected={(selectedStamps) => console.log("Selecionados:", selectedStamps)}
            conversationData = {conversationData}
      /> 

      <GroupDetails
          isOpen={openModal === "groupDetails"}
          onClose={() => setOpenModal(false)}
          participants={participants}
          isMobile={isMobile}
          socket={socket}
          onAddSelected={(selected) => console.log("Selecionados:", selected)}
          conversationData={conversationData}
          isAdmin={admin}
          ha
      />

      {/* Permite selecionar vários ficheiros de uma só vez. */}
      <input
        type="file"
        ref={fileInputRef}
        style={styles.hiddenInput}
        onChange={handleFileChange}
        multiple
      />    


    </div>
  );
}

export default ChatWindow;